// src/components/YaamavaNavBar/YaamavaNavBar.js
import React, { useEffect } from 'react';
import './YaamavaNavBar.css';
import { Link } from 'react-router-dom';
import SearchBar from '../SearchBar/SearchBar';

const YaamavaNav = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Scroll effect for background blur + color
  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector('.brand-yaamava');
      if (navbar) {
        navbar.classList.toggle('scrolled', window.scrollY > 50);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className="navbar navbar-expand-md bg-transparent w-100">
<div className="container-fluid brand-yaamava d-flex justify-content-evenly align-items-center w-100">

        {/* Navbar Header: Logo + Toggler */}
        <div className="d-flex align-items-center">
          {/* Toggler 1 */}
          <button
            className="navbar-toggler me-4 yaamavaToggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Logo 2 */}
          <Link className="navbar-brand d-flex align-items-center" to="/">
          <img
              src="/picz/yaamava/yaamavalogo.svg"
              alt="Yaamava logo"
              className="yaamava-icon"
              width="64"
              height="64"
            />
          </Link>

          {/* Account Button 3 */}
          <div className="nav-item">
            <a href="#" className="btn-Yaccount d-flex align-items-center">
              <img
                src="/picz/yaamava/user.svg"
                alt="LogIn"
                style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '36px',
                  marginRight: '4px',
                  verticalAlign: 'middle',
                }}
              />
              Club Serrano
            </a>
          </div>
        </div>
          
        {/* Collapsible Menu */}
        <div className="collapse navbar-collapse justify-content-center" id="navbarNav">
          <ul className="navbar-nav text-center">
            <li className="nav-item">
              <a
                className="nav-link brand-yaamava"
                onClick={() => scrollToSection('Casino')}
                style={{ cursor: 'pointer' }}
              >
                Casino Resort
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link brand-yaamava"
                onClick={() => scrollToSection('Giveaways')}
                style={{ cursor: 'pointer' }}
              >
                Giveaways
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link brand-yaamava"
                onClick={() => scrollToSection('Golf')}
                style={{ cursor: 'pointer' }}
              >
                Golf
              </a>
            </li>
            <a href="#" className="btn-Yaccount-mobile d-flex align-items-center">
              <img
                src="/picz/yaamava/user.svg"
                alt="LogIn"
                style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '36px',
                  marginRight: '4px',
                  verticalAlign: 'middle',
                }}
              />
              Club Serrano
            </a>
          </ul>
        </div>

        {/* Right-side items: Search + Account */}
        <div className="d-flex align-items-center">
          {/* Search Bar */}
          <div className="hide-on-850 me-3">
            <SearchBar onSearch={(query) => console.log('Searching for:', query)} />
          </div>

        </div>
      </div>
    </nav>
  );
};

export default YaamavaNav;
